export default "__VITE_ASSET__tvj5X9dr__"